import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {AngularFirestore} from "@angular/fire/firestore";
import {Observable} from "rxjs";
import {filter} from "rxjs/operators";
// import * as firebase from "firebase";

@Injectable({
  providedIn: "root",
})
export class LeadService {
  noAuthHeader = {
    headers: new HttpHeaders({"Content-Type": "application/json"}),
  };

  constructor(private http: HttpClient, private firestore: AngularFirestore) {
    this.firestore.firestore.settings({experimentalForceLongPolling: true});
  }

  //HttpMethods

  // create contact
  createContact(data): Observable<any> {
    return this.http.post("create_contact", data, this.noAuthHeader);
  }

  // Create Contact using RS2 import URLs
  createContactRS2Import(data): Observable<any> {
    // return this.http.post("create_contact_rs2_import", data, this.noAuthHeader);
    return this.http.post("import_rs2_contact", data, this.noAuthHeader);
  }

  // get all contacts
  getAllContacts() {
    return this.firestore
      .collection("contacts", (ref) => ref.orderBy("first_name", "asc"))
      .snapshotChanges();
  }

  // get filetered contacts..
  getFilteredContacts(uid) {
    return this.firestore
      .collection("contacts", (ref) =>
        ref
          .where("contact_type_id", "in", ["lead", "client"])
          .where("owner_user_id", "==", uid)
          .orderBy("first_name", "desc")
      )
      .snapshotChanges();
  }

  /*  getContactList(contactType,filterData, limit, lastVisible) {
      let query = this.firestore.collection("contacts").ref.orderBy('date_created','desc');
      
      if(contactType!="" && contactType!=null){
        query = query.where('contact_type_id', '==', contactType);
      }
      if(filterData && filterData.owner_contact_id){
        query = query.where('owner_contact_id', '==', filterData.owner_contact_id);
      }
      if(filterData && filterData.contact_source_id){
        query = query.where('contact_source_id', '==', filterData.contact_source_id);
      }
      if(filterData && filterData.showroom){
        const showroomArr = filterData.showroom.split(',');
        query = query.where('showroom', 'array-contains', {'showroom_id':showroomArr[0],'showroom_name':showroomArr[1]});
      }
      // query = query.startAfter(lastVisible).limit(limit);
      return this.firestore.collection("contacts", ref => query).snapshotChanges();
      // return this.firestore.collection("contacts", ref => ref.orderBy('date_created','desc')).snapshotChanges();
  }*/

  // Count total records...
  contactCount(
    listType,
    contactType,
    filterData,
    isDesigner,
    uid,
    searchContactIds
  ) {
    // let obj = {
    //   listType,
    //   contactType,
    //   filterData
    // }
    // return this.http.post("count_contacts", this.noAuthHeader);

    if (listType == "filtered") {
      let query = this.firestore
        .collection("contacts")
        .ref.where("contact_type_id", "in", ["lead", "client"])
        .where("owner_user_id", "==", uid);
      return this.firestore
        .collection("contacts", (ref) => query)
        .snapshotChanges();
    } else {
      let query = this.firestore
        .collection("contacts")
        .ref.orderBy("date_created", "desc");
      if (contactType != "" && contactType != null) {
        query = query.where("contact_type_id", "==", contactType);
      }
      // else {
      //   query = query.where('contact_type_id', 'in', ['architect','client','device','lead','signin','technical_designer']);
      // }
      if (isDesigner === true) {
        query = query.where("owner_user_id", "==", uid);
      }
      if (filterData && filterData.owner_contact_id) {
        query = query.where(
          "owner_contact_id",
          "==",
          filterData.owner_contact_id
        );
      }
      if (filterData && filterData.contact_source_id) {
        query = query.where(
          "contact_source_id",
          "==",
          filterData.contact_source_id
        );
      }
      // if(searchContactIds.length>0){
      //   query = query.where('contact_id', 'in', searchContactIds);
      // }

      if (filterData && filterData.showroom) {
        const showroomArr = filterData.showroom.split(",");
        query = query.where("showroom", "array-contains", {
          showroom_id: showroomArr[0],
          showroom_name: showroomArr[1],
        });
      }
      return this.firestore
        .collection("contacts", (ref) => query)
        .snapshotChanges();
    }
  }

  // Get contact list
  getContactList(
    listType,
    contactType,
    filterData,
    limit,
    isDesigner,
    uid,
    searchContactIds
  ) {
    // console.log(listType, "listType!!!!!", contactType, "contactType", filterData, "filterData", limit, "limit", isDesigner, "isDesigner");
    if (listType == "filtered") {
      let query;
      if (limit === 0) {
        query = this.firestore
          .collection("contacts")
          .ref.where("owner_user_id", "==", uid)
          .orderBy("date_created", "desc");
      } else {
        query = this.firestore
          .collection("contacts")
          .ref.where("owner_user_id", "==", uid)
          .orderBy("date_created", "desc")
          .limit(limit);
      }

      if (filterData && filterData.owner_contact_id) {
        query = query.where(
          "owner_contact_id",
          "==",
          filterData.owner_contact_id
        );
      }
      if (filterData && filterData.contact_source_id) {
        query = query.where(
          "contact_source_id",
          "==",
          filterData.contact_source_id
        );
      }
      if (filterData && filterData.showroom) {
        const showroomArr = filterData.showroom.split(",");
        query = query.where("showroom_default_id", "==", showroomArr[0]);
      }
      if (contactType != "" && contactType != null) {
        query = query.where("contact_type_id", "==", contactType);
      } else {
        query = query.where("contact_type_id", "in", ["lead", "client"]);
      }
      if (filterData.start_date) {
        query = query.where(
          "date_created",
          ">=",
          new Date(filterData.start_date).getTime()
        );
      }
      if (filterData.end_date) {
        query = query.where(
          "date_created",
          "<=",
          new Date(filterData.end_date).getTime()
        );
      }
      return this.firestore.collection("contacts", (ref) => query).get();
    } else {
      let query = this.firestore
        .collection("contacts")
        .ref.orderBy("date_created", "desc");
      if (filterData && filterData.owner_contact_id) {
        query = query.where(
          "owner_contact_id",
          "==",
          filterData.owner_contact_id
        );
      }
      // if(filterData && filterData.contact_source_id){
      //   query = query.where('contact_source_id', '==', filterData.contact_source_id);
      // }
      if (contactType != "" && contactType != null) {
        query = query.where("contact_type_id", "==", contactType);
      } else {
        query = query.where("contact_type_id", "in", ["lead", "client"]);
      }

      if (isDesigner === true) {
        query = query.where("owner_user_id", "==", uid);
      }
      if (filterData.start_date) {
        query = query.where(
          "date_created",
          ">=",
          new Date(filterData.start_date).getTime()
        );
      }
      if (filterData.end_date) {
        query = query.where(
          "date_created",
          "<=",
          new Date(filterData.end_date).getTime()
        );
      }

      if (searchContactIds.length > 0) {
        query = query.where("contact_id", "in", searchContactIds);
      }
      if (filterData && filterData.showroom) {
        const showroomArr = filterData.showroom.split(",");
        query = query.where("showroom_default_id", "==", showroomArr[0]);
      }
      if (limit == 0) {
        return this.firestore.collection("contacts", (ref) => query).get();
      } else {
        return this.firestore
          .collection("contacts", (ref) => query.limit(limit))
          .get();
      }
    }

    // return this.firestore.collection("contacts",
    // ref => ref.limit(5).
    // orderBy('date_created','desc')
    // ).snapshotChanges();
  }

  getPreContactList(
    contactType,
    filterData,
    limit,
    isDesigner,
    uid,
    prevStartAt,
    firstInResponse,
    searchContactIds = []
  ) {
    let query = this.firestore
      .collection("contacts")
      .ref.orderBy("date_created", "desc")
      .startAt(prevStartAt)
      .endBefore(firstInResponse)
      .limit(limit);

    if (contactType != "" && contactType != null) {
      query = query.where("contact_type_id", "==", contactType);
    }
    if (isDesigner === true) {
      query = query.where("owner_user_id", "==", uid);
    }
    // else {
    //   query = query.where('contact_type_id', 'in', ['architect','client','device','lead','signin','technical_designer']);
    // }

    if (filterData && filterData.owner_contact_id) {
      query = query.where(
        "owner_contact_id",
        "==",
        filterData.owner_contact_id
      );
    }
    if (filterData && filterData.contact_source_id) {
      query = query.where(
        "contact_source_id",
        "==",
        filterData.contact_source_id
      );
    }
    if (searchContactIds.length > 0) {
      query = query.where("contact_id", "in", searchContactIds);
    }
    if (filterData && filterData.showroom) {
      const showroomArr = filterData.showroom.split(",");
      query = query.where("showroom_default_id", "==", showroomArr[0]);
    }
    return this.firestore.collection("contacts", (ref) => query).get();

    /*return this.firestore.collection("contacts", 
    ref => ref.
    orderBy('date_created','desc')
    .startAt(prevStartAt)
    .endBefore(firstInResponse)
    .limit(5)
    ).get();*/
  }

  // Get next contact list...
  getNextContactList(
    listType,
    contactType,
    filterData,
    limit,
    isDesigner,
    uid,
    lastInResponse,
    searchContactIds = []
  ) {
    // console.log(listType, "listType!!!!!", contactType, "contactType", filterData, "filterData", limit, "limit", isDesigner, "isDesigner", searchContactIds, "searchContactIds");

    if (listType === "filtered") {
      let query = this.firestore
        .collection("contacts")
        .ref.where("owner_user_id", "==", uid)
        .orderBy("date_created", "desc")
        .startAfter(lastInResponse)
        .limit(limit);
      if (contactType != "" && contactType != null) {
        query = query.where("contact_type_id", "==", contactType);
      } else {
        query = query.where("contact_type_id", "in", ["lead", "client"]);
      }
      if (filterData.start_date) {
        query = query.where(
          "date_created",
          ">=",
          new Date(filterData.start_date).getTime()
        );
      }
      if (filterData.end_date) {
        query = query.where(
          "date_created",
          "<=",
          new Date(filterData.end_date).getTime()
        );
      }
      return this.firestore.collection("contacts", (ref) => query).get();
    } else {
      let query = this.firestore
        .collection("contacts")
        .ref.orderBy("date_created", "desc")
        .startAfter(lastInResponse)
        .limit(limit);

      if (contactType != "" && contactType != null) {
        query = query.where("contact_type_id", "==", contactType);
      } else {
        query = query.where("contact_type_id", "in", ["lead", "client"]);
      }
      if (isDesigner === true) {
        query = query.where("owner_user_id", "==", uid);
      }
      if (filterData.start_date) {
        query = query.where(
          "date_created",
          ">=",
          new Date(filterData.start_date).getTime()
        );
      }
      if (filterData.end_date) {
        query = query.where(
          "date_created",
          "<=",
          new Date(filterData.end_date).getTime()
        );
      }
      if (filterData && filterData.owner_contact_id) {
        query = query.where(
          "owner_contact_id",
          "==",
          filterData.owner_contact_id
        );
      }
      // if(filterData && filterData.contact_source_id){
      //   query = query.where('contact_source_id', '==', filterData.contact_source_id);
      // }

      if (searchContactIds.length > 0) {
        query = query.where("contact_id", "in", searchContactIds);
      }
      if (filterData && filterData.showroom) {
        const showroomArr = filterData.showroom.split(",");
        query = query.where("showroom_default_id", "==", showroomArr[0]);
      }
      return this.firestore.collection("contacts", (ref) => query).get();
    }
  }

  // Export contact list
  async exportContactList(
    listType,
    contactType,
    filterData,
    isDesigner,
    uid,
    searchContactIds
  ) {
    if (listType == "filtered") {
      let query = this.firestore
        .collection("contacts")
        .ref.where("owner_user_id", "==", uid)
        .orderBy("date_created", "desc");

      if (filterData && filterData.owner_contact_id) {
        query = query.where(
          "owner_contact_id",
          "==",
          filterData.owner_contact_id
        );
      }
      if (filterData && filterData.contact_source_id) {
        query = query.where(
          "contact_source_id",
          "==",
          filterData.contact_source_id
        );
      }
      if (contactType != "" && contactType != null) {
        query = query.where("contact_type_id", "==", contactType);
      } else {
        query = query.where("contact_type_id", "in", ["lead", "client"]);
      }
      if (filterData && filterData.showroom) {
        const showroomArr = filterData.showroom.split(",");
        query = query.where("showroom", "array-contains", {
          showroom_id: showroomArr[0],
          showroom_name: showroomArr[1],
        });
      }
      if (filterData.start_date) {
        query = query.where("date_created", ">=", filterData.start_date);
      }
      if (filterData.end_date) {
        query = query.where("date_created", "<=", filterData.end_date);
      }
      // return this.firestore.collection("contacts", ref => query).snapshotChanges();
      const snapshot = await this.firestore
        .collection("contacts", (ref) => query)
        .get();
      return snapshot;
    } else {
      let query = this.firestore
        .collection("contacts")
        .ref.orderBy("date_created", "desc");
      if (filterData && filterData.owner_contact_id) {
        query = query.where(
          "owner_contact_id",
          "==",
          filterData.owner_contact_id
        );
      }
      if (filterData && filterData.contact_source_id) {
        query = query.where(
          "contact_source_id",
          "==",
          filterData.contact_source_id
        );
      }
      if (contactType != "" && contactType != null) {
        query = query.where("contact_type_id", "==", contactType);
      } else {
        query = query.where("contact_type_id", "in", ["lead", "client"]);
      }

      if (isDesigner === true) {
        query = query.where("owner_user_id", "==", uid);
      }
      if (filterData.start_date) {
        query = query.where("date_created", ">=", filterData.start_date);
      }
      if (filterData.end_date) {
        query = query.where("date_created", "<=", filterData.end_date);
      }

      if (searchContactIds.length > 0) {
        query = query.where("contact_id", "in", searchContactIds);
      }

      if (filterData && filterData.showroom) {
        const showroomArr = filterData.showroom.split(",");
        query = query.where("showroom_default_id", "==", showroomArr[0]);
        //query = query.where('showroom', 'array-contains', {'showroom_id':showroomArr[0],'showroom_name':showroomArr[1]});
      }
      const snapshot = await this.firestore
        .collection("contacts", (ref) => query)
        .get();
      return snapshot;

      // return this.firestore.collection ("contacts", ref => query).snapshotChanges();
    }

    // return this.firestore.collection("contacts",
    // ref => ref.limit(5).
    // orderBy('date_created','desc')
    // ).snapshotChanges();
  }

  // get contact by ic
  getContactById(contactId) {
    return this.firestore
      .collection("contacts")
      .doc(contactId)
      .snapshotChanges();
  }

  getContactListWithNameId() {
    return this.firestore
      .collection("contacts", (ref) => ref.orderBy("date_created", "desc"))
      .snapshotChanges();
  }

  getDesignerList(param = null) {
    if (param === "all") {
      return this.firestore
        .collection("contacts", (ref) =>
          ref
            .where("contact_type_id", "==", "staff")
            .where("job_functions", "array-contains", "designer")
            .orderBy("first_name", "asc")
        )
        .snapshotChanges();
    } else {
      return this.firestore
        .collection("contacts", (ref) =>
          ref
            .where("contact_type_id", "==", "staff")
            .where("user_id", "==", param)
            .where("job_functions", "array-contains", "designer")
        )
        .snapshotChanges();
    }
  }

  // get associate list
  getAssociateList() {
    return this.firestore
      .collection("contacts", (ref) => ref.where("is_associate", "==", "Yes"))
      .snapshotChanges();
  }

  // delete lead
  deleteLead(uid) {
    return this.firestore.collection("contacts").doc(uid).delete();
  }

  // delete lead projects
  deleteLeadProject(uid) {
    return this.http.delete(
      "delete_lead_projects?uid=" + uid,
      this.noAuthHeader
    );
  }

  // get contacts details
  getContactDetail(id) {
    return this.firestore.collection("contacts").doc(id).snapshotChanges();
  }

  // get contact details using promise
  async getContactDetail2(id) {
    return await new Promise((resolve) => {
      this.firestore
        .collection("contacts")
        .doc(id)
        .snapshotChanges()
        .subscribe((list) => {
          resolve(list);
        });
    });
  }

  //  edit contact
  updateContact(form, id) {
    return this.firestore.collection("contacts").doc(id).update(form);
  }

  // get file list
  getFileList() {
    return this.firestore
      .collection("files", (ref) => ref.orderBy("date_created", "desc"))
      .snapshotChanges();
  }

  // add appointment...
  addAppointment(form) {
    const id = this.firestore.createId();
    form.id = id;
    return this.firestore.collection("appointments").doc(id).set(form);
  }

  //add reminder
  addReminder(form) {
    const id = this.firestore.createId();
    form.id = id;
    form.type = "reminder";
    return this.firestore.collection("comments").doc(id).set(form);
  }

  // Edit Reminder
  editReminder(form, id) {
    return this.firestore.collection("comments").doc(id).update(form);
  }

  // Get Reminder by Id
  getReminderById(id) {
    return this.firestore.collection("comments").doc(id).snapshotChanges();
  }

  // add note
  addNote(form) {
    const id = this.firestore.createId();
    form.id = id;
    form.type = "note";
    return this.firestore.collection("comments").doc(id).set(form);
  }

  // Code to get the appointment list
  getAppointmentList(params) {
    if (params.projectId) {
      return this.firestore
        .collection("calendar_events", (ref) =>
          ref.where("project_id", "==", params.projectId)
        )
        .snapshotChanges();
    } else if (params.contactId) {
      return this.firestore
        .collection("calendar_events", (ref) =>
          ref.where("contact_id", "==", params.contactId)
        )
        .snapshotChanges();
    } else {
      return this.firestore.collection("calendar_events").snapshotChanges();
    }
  }

  // code to get reminders list
  getReminderList(params) {
    if (params.projectId) {
      return this.firestore
        .collection("comments", (ref) =>
          ref
            .where("project_id", "==", params.projectId)
            .where("type", "==", "reminder")
        )
        .snapshotChanges();
    } else if (params.contactId) {
      return this.firestore
        .collection("comments", (ref) =>
          ref
            .where("contact_id", "==", params.contactId)
            .where("type", "==", "reminder")
        )
        .snapshotChanges();
    } else {
      return this.firestore
        .collection("comments", (ref) => ref.where("type", "==", "reminder"))
        .snapshotChanges();
    }
  }

  // code to get notes list
  getNotesList(params) {
    if (params.projectId) {
      return this.firestore
        .collection("comments", (ref) =>
          ref
            .where("project_id", "==", params.projectId)
            .where("type", "==", "note")
        )
        .snapshotChanges();
    } else if (params.contactId) {
      return this.firestore
        .collection("comments", (ref) =>
          ref
            .where("contact_id", "==", params.contactId)
            .where("type", "==", "note")
        )
        .snapshotChanges();
    } else {
      return this.firestore
        .collection("comments", (ref) => ref.where("type", "==", "note"))
        .snapshotChanges();
    }
  }
  // get categories list
  getCategoriesList() {
    return this.firestore
      .collection("project_map_step_categories")
      .snapshotChanges();
  }

  // get project map step category file list
  getCategoryFileList() {
    return this.firestore
      .collection("project_map_step_category_files")
      .snapshotChanges();
  }

  validateNID(nid): Observable<any> {
    // return this.http.post("create_contact_rs2_import", data, this.noAuthHeader);
    return this.http.get("rs2_node_redirect?nid=" + nid, this.noAuthHeader);
  }

  createSignin(form) {
    const id = this.firestore.createId();
    form.id = id;
    return this.firestore.collection("signins").doc(id).set(form);
  }

  // async getOCFilesPromise(params){
  //   return await new Promise(resolve =>{this.firestore.collection("files", ref => ref.where('project_id', '==', params.project_id).where('project_map_field_id', '==', params.project_map_field_id)).snapshotChanges().subscribe(list =>{
  //     resolve(list);
  //   })
  // })
  // }

  async getProjectMapNodePromise(project_id) {
    // return this.firestore.collection('project_map_nodes', ref => ref.where('project_id', '==', project_id)).snapshotChanges();
    return await new Promise((resolve) => {
      // .orderBy('date_created', 'desc')
      this.firestore
        .collection("project_map_nodes", (ref) =>
          ref
            .where("project_id", "==", project_id)
            .orderBy("date_created", "desc")
        )
        .snapshotChanges()
        .subscribe((list) => {
          resolve(list);
        });
    });
  }

  // edit contact settings collection
  fetchContactSettings(userId) {
    return this.firestore
      .collection("contact_settings", (ref) =>
        ref.where("user_id", "==", userId)
      )
      .snapshotChanges();
  }

  // edit contact settings collection
  editContactSettings(form, id) {
    return this.firestore.collection("contact_settings").doc(id).update(form);
  }
}
